import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * The product details which need to be passed in to show it inside the dialog.
 */

/**
 * Use baseUrl to generate advanced search URL for a specific workspace
 */

export var INITIAL_STATE = [];
export var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'ADD':
      {
        var newProduct = action.payload;
        return addProduct(state, newProduct);
      }
    case 'UPDATE':
      {
        var updatePayload = action.payload;
        return updateProduct(state, updatePayload);
      }
    case 'SHOW':
      {
        var productIdToShow = action.payload.id;
        return showProduct(state, productIdToShow);
      }
    case 'REMOVE':
      {
        var productIdToRemove = action.payload.id;
        return removeProduct(state, productIdToRemove);
      }
    case 'HIDE_ALL':
      {
        return hideAllProducts(state);
      }
    default:
      {
        return state;
      }
  }
};
export function addProduct(products, addPayload) {
  // Check that new product id does not exist already
  if (products.filter(function (product) {
    return product.id === addPayload.id;
  }).length) {
    return products;
  }

  // Show error in console when duplicate order is added
  var duplicateOrder = products.find(function (_ref) {
    var order = _ref.order;
    return order === addPayload.order;
  });
  if (duplicateOrder) {
    // eslint-disable-next-line no-console
    console.error("product-search-dialog: Duplicate order of ".concat(addPayload.order, " has been set for the products of ").concat(duplicateOrder.id, " and ").concat(addPayload.id));
  }

  // Add product to state and maintain sorted array using order
  var newProduct = _objectSpread(_objectSpread({}, addPayload), {}, {
    isDisplayed: false
  });
  var unsorted = [].concat(_toConsumableArray(products), [newProduct]);
  var sorted = unsorted.sort(function (a, b) {
    return a.order - b.order;
  });
  return sorted;
}
export function updateProduct(products, updatePayload) {
  var productToUpdate = products.find(function (p) {
    return p.id === updatePayload.id;
  });
  if (!productToUpdate) {
    throw new Error("Cannot update ".concat(updatePayload.id, " before being added"));
  }
  var validUpdateKeys = ['generateAdvancedSearchUrl', 'tabRenderer'];
  var validUpdatePayload = Object.fromEntries(Object.entries(updatePayload).filter(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
      key = _ref3[0];
    return validUpdateKeys.includes(key);
  }));
  Object.assign(productToUpdate, validUpdatePayload);
  return products;
}
export function showProduct(products, productIdToShow) {
  return products.map(function (product) {
    return _objectSpread(_objectSpread({}, product), {}, {
      isDisplayed: product.id === productIdToShow
    });
  });
}
export function removeProduct(products, productIdToRemove) {
  return products.filter(function (product) {
    return product.id !== productIdToRemove;
  });
}
export function hideAllProducts(products) {
  return products.map(function (product) {
    return _objectSpread(_objectSpread({}, product), {}, {
      isDisplayed: false
    });
  });
}